import {
  AVAILABLE_LICENSES_URL,
  GENERATE_LICENSE_URL,
  GET_LICENSE_DETAIL_URL,
  GET_REFERENCES_URL,
  GET_RESOURCE_REFERENCES_URL,
  LICENSES_URL,
  LICENSE_REFRESH_URL,
  MY_VMWARE_ACCOUNT_URL,
  SYNC_USAGE,
  VRCSM_BILLING_DATE,
  SUBSCRIPTION_MANAGER_KEY_URL,
  DOWNLOAD_BILLING_REPORT
} from '../../constants/ApiUri';
import {
  BillingDates,
  Environments,
  License,
  LicenseDetailProperties,
  LicenseReferencesPayload,
  LicenseRefresh,
  UpdateSubscriptionManagerKeyPayload,
  ValidateLicense
} from '../../types/resources/State';

import { Http } from 'vrlcm-gui-utils';
import { WeeklyReport } from '../../types/resources/License';
import {
  ReferenceResponse,
  RequestId,
  RequestName,
  RequestState
} from 'vrlcm-gui-types';
import { RequestApi } from 'vrlcm-gui-api';

export default class LicenseAPI {
  public static getLicenses = (): Promise<WeeklyReport[]> => {
    return Http.get(LICENSES_URL).then(res => res.data);
  };
  public static getAvailableLicenses = (): Promise<License[]> => {
    return Http.get(AVAILABLE_LICENSES_URL).then(res => res.data);
  };
  public static generateReport = (
    licenseId: string
  ): Promise<ValidateLicense> => {
    return Http.get(GENERATE_LICENSE_URL(licenseId)).then(res => res.data);
  };
  public static getVrcsmBillingDates = (
    licenseId: string
  ): Promise<BillingDates> => {
    return Http.get(VRCSM_BILLING_DATE(licenseId)).then(res => res.data);
  };
  public static isDownloadUsageRequestInProgress =
    async (): Promise<boolean> => {
      const requests = await RequestApi.getRequestWithQueryOptions({
        filter: {
          requestTypes: [RequestName.licenseusagedownload],
          requestStates: [RequestState.INPROGRESS]
        },
        sortByDirection: 'DESC',
        sortBy: 'lastUpdatedOn',
        limit: 1
      });
      return requests.length > 0;
    };
  public static downloadBillingLicenseReport = (
    licenseId: string,
    mask: boolean
  ): Promise<RequestId> => {
    return Http.get(DOWNLOAD_BILLING_REPORT(licenseId, mask)).then(
      res => res.data
    );
  };

  public static getChooseLicenseReferences = (
    VMID: string
  ): Promise<ReferenceResponse> => {
    return Http.get(GET_REFERENCES_URL(VMID)).then(res => res.data);
  };
  public static getLicenseDetail = (
    payload: LicenseReferencesPayload
  ): Promise<License> => {
    const VMID = payload.licenseVMID;
    return Http.get(GET_LICENSE_DETAIL_URL(VMID)).then(res => res.data);
  };
  public static triggerSyncUsage = (
    payload: LicenseReferencesPayload
  ): Promise<string> => {
    const VMID = payload.licenseVMID;
    return Http.post(SYNC_USAGE(VMID)).then(res => res.data.requestId);
  };

  public static updateSubscriptionManagerKey = (
    payload: UpdateSubscriptionManagerKeyPayload
  ): Promise<LicenseDetailProperties> => {
    return Http.post(SUBSCRIPTION_MANAGER_KEY_URL, payload).then(
      res => res.data
    );
  };
  public static getLicenseReferences = (
    payload: LicenseReferencesPayload
  ): Promise<Environments> => {
    const VMID = payload.licenseVMID;
    return Http.get(GET_RESOURCE_REFERENCES_URL(VMID)).then(res => res.data);
  };
  public static onLicenseRefresh = (): Promise<LicenseRefresh> => {
    return Http.get(LICENSE_REFRESH_URL).then(res => res.data);
  };
  public static getLicenseData = (
    VMID: string
  ): Promise<LicenseDetailProperties> => {
    return Http.get(GET_LICENSE_DETAIL_URL(VMID)).then(res => res.data);
  };
  public static getMyVmwareAccounts = (): Promise<number> => {
    return Http.get(MY_VMWARE_ACCOUNT_URL).then(res => res.data.length);
  };
}
